import locale from "localization/en";

export const columns = [
  { key: "brand", text: locale.brand, width: "250px" },
  { key: "product", text: locale.product, width: "200px" },
  { key: "fuelCategory", text: locale.fuelCategory, width: "200px" },
  { key: "benchMark", text: locale.benchMark, width: "200px" },
  { key: "actions", text: locale.action, width: "100px" },
];
